import React from 'react';
import { Card, Tag, Button } from 'antd';
import { EyeOutlined, GlobalOutlined } from '@ant-design/icons';
import { Brand } from '../services/api';
import FavoriteButton from './FavoriteButton';
import { useTranslation } from 'react-i18next';

interface BrandCardProps {
  brand: Brand;
  onViewDetails: (id: number) => void;
  initialFavoriteStatus?: boolean;
}

const BrandCard: React.FC<BrandCardProps> = ({
  brand,
  onViewDetails,
  initialFavoriteStatus,
}) => {
  const { t } = useTranslation();

  return (
    <Card
      hoverable
      style={{ marginBottom: 16, cursor: 'pointer' }}
      onClick={() => onViewDetails(brand.id)}
      actions={[
        <Button
          type="link"
          icon={<EyeOutlined />}
          onClick={e => {
            e.stopPropagation();
            onViewDetails(brand.id);
          }}
        >
          {t('brand_card.view_details')}
        </Button>,
        <FavoriteButton
          key="favorite"
          brandId={brand.id}
          type="link"
          initialFavoriteStatus={initialFavoriteStatus}
        />,
        brand.website && (
          <Button
            type="link"
            icon={<GlobalOutlined />}
            href={brand.website}
            target="_blank"
          >
            {t('brand_card.website')}
          </Button>
        ),
      ].filter(Boolean)}
    >
      <Card.Meta
        title={brand.name}
        description={
          <div>
            <p style={{ marginBottom: 8 }}>{brand.description}</p>
            <p style={{ marginBottom: 8, color: '#666' }}>
              {t('brand_card.founded')}: {new Date(brand.founded).getFullYear()}{' '}
              | {t('brand_card.headquarters')}: {brand.headquarters}
            </p>
            <div>
              {brand.categories.map(category => (
                <Tag key={category} color="blue">
                  {category}
                </Tag>
              ))}
            </div>
          </div>
        }
      />
    </Card>
  );
};

export default BrandCard;
